import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n\n  *::selection {\n    background: ", ";\n  }\n\n  ul {\n    padding-left: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  body {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components';
import { baseFontStyles } from "./fonts";
import { normalize } from 'styled-normalize';
import 'focus-visible';
import { theme } from "./theme";
export var GlobalStyle = createGlobalStyle(_templateObject(), normalize, theme.colors.palette.brandPrimaryAlpha, baseFontStyles);